export default __webpack_public_path__ + "static/media/YanoneKaffeesatz-VariableFont_wght.c775e7c1.ttf";